import { Popconfirm } from 'antd'
import {
    DeleteFilled,
    EditFilled
} from '@ant-design/icons'
import { getIndiaFormatNumber } from '../../utils/util'
export const getColumns = (filters) => {
    return [
        {
            title: 'Name',
            dataIndex: 'scheme_name',
            key: 'scheme_name',
            fixed: "left",
            sorter: (a, b) => a.scheme_name.localeCompare(b.scheme_name)
        },
        {
            title: 'Total Profit',
            dataIndex: 'profit',
            key: 'profit',
            sorter: (a, b) => a.profit - b.profit,
            render: ((d, a) => {
                return d ? getIndiaFormatNumber(a.profit) : ""
            }),
        },
        {
            title: 'Total Profit Percent',
            dataIndex: 'profitPercent',
            key: 'profitPercent',
            sorter: (a, b) => a.profitPercent - b.profitPercent,
            render: ((d, a) => {
                return d ? (100 * a.profitPercent).toFixed(2) + " %" : ""
            }),
        },
        {
            title: 'Last Day Profit',
            dataIndex: 'oneDayProfit',
            key: 'oneDayProfit',
            sorter: (a, b) => a.oneDayProfit - b.oneDayProfit,
            render: ((d, a) => {
                return d ? getIndiaFormatNumber(a.oneDayProfit) : ""
            }),
        },
        {
            title: 'Last Day Profit Percent',
            dataIndex: 'oneDayProfitPercent',
            key: 'oneDayProfitPercent',
            sorter: (a, b) => a.oneDayProfitPercent - b.oneDayProfitPercent,
            render: ((d, a) => {
                return d ? (100 * a.oneDayProfitPercent).toFixed(2) + " %" : ""
            }),
        },
        {
            title: 'Invested Amount',
            dataIndex: 'amount',
            key: 'amount',
            sorter: (a, b) => a.amount - b.amount,
            render: ((d) => {
                return d ? getIndiaFormatNumber(d) : d
            }),
        },
        {
            title: 'Current Value',
            dataIndex: 'currentValue',
            key: 'currentValue',
            sorter: (a, b) => a.currentValue - b.currentValue,
            render: ((d) => {
                return d ? getIndiaFormatNumber(d) : d
            }),

        },
        {
            title: 'Invested By',
            dataIndex: 'investedBy',
            key: 'investedBy',
            filteredValue: filters["investedBy"],
            filterSearch: true,
            render: ((d) => {
                return d ? d.join(", ") : ""
            }),

        },

    ]
}

export const getTransactionColumns = (handleTransactionDelete, showModal) => {
    return [
        {
            title: 'Invested Amount',
            dataIndex: 'amount',
            key: 'amount',
            sorter: (a, b) => a.amount - b.amount,
            render: ((d) => {
                return d ? getIndiaFormatNumber(d) : d
            }),
        },
        {
            title: 'Current Value',
            dataIndex: 'currentValue',
            key: 'currentValue',
            sorter: (a, b) => a.currentValue - b.currentValue,
            render: ((d) => {
                return d ? getIndiaFormatNumber(d) : d
            }),
        },
        {
            title: 'Total Profit',
            dataIndex: 'profit',
            key: 'profit',
            sorter: (a, b) => a.profit - b.profit,
            render: ((d) => {
                return d ? getIndiaFormatNumber(d) : d
            }),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            sorter: (a, b) => a.profit - b.profit,
        }, {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: ((d) => {
                return new Date(d).toLocaleDateString()
            }),
            sorter: (a, b) => a.profit - b.profit,
        },
        {
            title: 'Invested By',
            dataIndex: 'investedBy',
            key: 'investedBy',
            render: ((d) => {
                return d
            }),
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            render: (_, record) => {
                return (
                    <div>
                        <EditFilled className="transaction-edit-icon" onClick={() => showModal(record._id)} />
                        <Popconfirm title="Sure to delete?" onConfirm={() => handleTransactionDelete(record._id)}>
                            <DeleteFilled className="transaction-delete-icon" />
                        </Popconfirm >
                    </div>

                )
            }
        }
    ]
}